import type { ResolvedEspdCriterionDto } from "../../../../../autogen/bff-api";

export type EspdPresentationText = {
  titleText?: {
    en: string;
    no: string;
  };
  helperText?: {
    en: string;
    no: string;
  };
};

const eoDataPresentationByTypeCode: Record<string, EspdPresentationText> = {
  // ESPD cbc:Name values are XML validation labels (for example "EO registered").
  // Keep canonical ESPD IDs/data intact, but use supplier-facing headings in the form.
  "CRITERION.OTHER.EO_DATA.REGISTERED_IN_OFFICIAL_LIST": {
    titleText: {
      en: "Official list or qualification certificate",
      no: "Offisiell liste eller kvalifikasjonsattest",
    },
  },
  "CRITERION.OTHER.EO_DATA.TOGETHER_WITH_OTHERS": {
    titleText: {
      en: "Participation with other suppliers",
      no: "Deltakelse sammen med andre leverandører",
    },
  },
  "CRITERION.OTHER.EO_DATA.RELIES_ON_OTHER_CAPACITIES": {
    titleText: {
      en: "Support from other entities",
      no: "Støtte fra andre virksomheter",
    },
  },
  "CRITERION.OTHER.EO_DATA.SUBCONTRACTS_WITH_THIRD_PARTIES": {
    titleText: {
      en: "Subcontractors",
      no: "Underleverandører",
    },
  },
};

export const presentationForCriterion = (
  criterion: ResolvedEspdCriterionDto,
): EspdPresentationText | undefined => {
  return eoDataPresentationByTypeCode[criterion.typeCode];
};
